import React from "react";
import { Helmet } from "react-helmet-async";
import { appUrl } from "../../../constants/url-constants";
import ErrorHandler from "../../../components/shared/with-error-handler";
import withLayout from "../../../components/desktop/layout/component";
import ClassifiedCars24Info from "../../../components/desktop/classified-cars24-info";
import withReducer from "../../../components/shared/with-reducer";
import injectableReducers from "./injectable";

const ClassifiedCars24 = () => {
    return (
        <React.Fragment>
            <Helmet>
                <title>
        Classified vs CARS24 - Know Why CARS24 is Better? - CARS24
                </title>
                <meta name="description"
                    content="Know Why Selling your used car via online classifieds
             is not a great Idea! CARS24 listed out some major concerns
              which online classifieds does not take care of." />
                <link href={`${appUrl()}/classified-vs-cars24/`} rel="canonical" />
                <meta name="keywords" content="Classified vs Cars24, Difference between
         classified vs cars24, cars24 vs classifieds" />
            </Helmet>
            <ErrorHandler>
                <ClassifiedCars24Info />
            </ErrorHandler>
        </React.Fragment>
    );
};

export default withReducer(injectableReducers)(() => ({}), dispatch => ({ dispatch }))(withLayout(ClassifiedCars24));
